document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.tab-button');
  const contents = document.querySelectorAll('.tab-content');

  buttons.forEach(button => {
    button.addEventListener('click', function () {
      // Remove active class from all
      buttons.forEach(btn => btn.classList.remove('active'));
      contents.forEach(content => content.classList.remove('active'));

      // Add active class to clicked button and related content
      this.classList.add('active');
      const tabId = this.getAttribute('data-tab');
      const activeContent = document.getElementById(tabId);
      activeContent.classList.add('active');
    });
  });
});
